export const GET_PRODUCT_BY_NAME_REQUEST = "GET_PRODUCT_BY_NAME_REQUEST";
export const GET_PRODUCT_BY_NAME_SUCCESS = "GET_PRODUCT_BY_NAME_SUCCESS";
export const GET_PRODUCT_BY_NAME_FAIL = "GET_PRODUCT_BY_NAME_FAIL";
